import { connect } from 'react-redux';

import {
  toggleDrawer,
  setInitialPermissions,
  setRoleRequestBody,
  setEditPermissions,
  setIsLoadingRole,
  setRole,
} from '../redux/actions';

import RoleDrawer from './RoleDrawer';

const mapStateToProps = (state) => {
  return {
    drawerOpen: state.rolesPermissions.drawerOpen,
    drawerTitle: state.rolesPermissions.drawerTitle,
    customPermissions: state.rolesPermissions.customPermissions,
    role: state.rolesPermissions.role,
    tabsMacros: state.rolesPermissions.tabsMacros,
  };
};

const mapDispatchToProps = {
  toggleDrawer,
  setInitialPermissions,
  setRoleRequestBody,
  setEditPermissions,
  setIsLoadingRole,
  setRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleDrawer);
